/** Changes starts with an event; related records are created inside that event. */
import { Plus, Save, Loader2 } from '@/shared/ui/icons';
import type { MobileHeaderAction } from './types';

export interface EventsHeaderCtx {
  leadingActions: MobileHeaderAction[];
  trailingActions: MobileHeaderAction[];
}

export function buildEventsHeaderActions(ctx: EventsHeaderCtx): void {
  ctx.trailingActions.push({
    id: 'project-event-create',
    icon: Plus,
    ariaLabel: 'Create an event',
    group: 'page',
    onClick: () => window.dispatchEvent(new CustomEvent('project-event:create-new')),
  });
}

export interface EventEditorHeaderState {
  title: string;
  hasChanges: boolean;
  canSave: boolean;
  isSaving: boolean;
}

export function buildEventEditorHeaderActions(state: EventEditorHeaderState): MobileHeaderAction[] {
  if (!state.hasChanges) return [];
  return [
    { id: 'event-form-cancel', label: 'Cancel', ariaLabel: 'Cancel event', disabled: state.isSaving, group: 'page', onClick: () => window.dispatchEvent(new Event('project-event-form:cancel')) },
    { id: 'event-form-save', icon: state.isSaving ? Loader2 : Save, ariaLabel: state.isSaving ? 'Saving event' : 'Save event', disabled: state.isSaving || !state.canSave, group: 'page', onClick: () => window.dispatchEvent(new Event('project-event-form:save')) },
  ];
}
